import { Platform, StyleSheet } from 'react-native';
import { AdminColors } from '../../constants/adminColors';
import FontFamily from '../../../../constants/fonts';

export const modalStyles = StyleSheet.create({
  section: {
    fontSize: 14,
    fontWeight: '700',
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.bold,
    borderBottomWidth: 1,
    borderBottomColor: AdminColors.gray25,
    paddingBottom: 5,
    marginBottom: 8,
    marginTop: 10,
  },
  row: {
    flexDirection: 'row',
    gap: 12,
  },
  half: {
    flex: 1,
  },
  ctx: {
    fontSize: 13,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.regular,
    lineHeight: 20,
    marginBottom: 10,
  },
  textArea: {
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 6,
    fontSize: 13,
    color: AdminColors.textPrimary,
    backgroundColor: AdminColors.bgSurface,
    fontFamily: FontFamily.regular,
    minHeight: 80,
    textAlignVertical: 'top',
    marginTop: 10,
  },
});

export const dialogStyles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  box: {
    backgroundColor: AdminColors.bgSurface,
    borderRadius: 10,
    padding: 24,
    maxWidth: 460,
    width: '100%' as any,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.2,
    shadowRadius: 24,
    elevation: 20,
  },
  title: {
    fontSize: 16,
    fontWeight: '700',
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.bold,
    marginBottom: 10,
  },
  msg: {
    fontSize: 13,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.regular,
    lineHeight: 20,
    marginBottom: 20,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 10,
  },
});

export const panelStyles = StyleSheet.create({
  panelBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(18, 35, 55, 0.45)',
  },
  panelShell: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 'auto',
    alignSelf: 'flex-end',
    maxWidth: '100%',
    maxHeight: '100%',
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    overflow: 'hidden',
    backgroundColor: AdminColors.bgPage,
    ...Platform.select({
      ios: { shadowColor: '#005EBF', shadowOffset: { width: -4, height: 0 }, shadowOpacity: 0.2, shadowRadius: 24 },
      android: { elevation: 16 },
    }),
  },
  formSection: {
    marginBottom: 14,
  },
  formSectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: AdminColors.borderDefault,
    paddingBottom: 7,
  },
  formSectionTitle: {
    fontSize: 12,
    fontWeight: '700',
    color: AdminColors.blue900,
    fontFamily: FontFamily.bold,
  },
  formSectionChevron: {
    fontSize: 14,
    color: AdminColors.textMuted,
  },
  formSectionBody: {
    paddingTop: 14,
  },
  formGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  formFieldWrap: {
    flexBasis: '24%',
    flexGrow: 0,
    flexShrink: 0,
    minWidth: 155,
  },
  formFieldSpan2: {
    flexBasis: '100%',
    flex: 0,
  },
  edfBadge: {
    marginLeft: 'auto',
    height: 16,
    paddingHorizontal: 5,
    borderRadius: 3,
    backgroundColor: '#EEF3F9',
    borderWidth: 1,
    borderColor: '#B8CBE3',
    justifyContent: 'center',
    alignItems: 'center',
  },
  edfBadgeText: {
    fontSize: 9,
    fontWeight: '700',
    color: AdminColors.blue800,
    fontFamily: FontFamily.bold,
    textTransform: 'uppercase',
  },
  bulkNote: {
    marginBottom: 12,
    padding: 10,
    borderRadius: 6,
    backgroundColor: '#EAF4FF',
    borderWidth: 1,
    borderColor: '#B8D7FB',
  },
  bulkNoteText: {
    fontSize: 11,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.regular,
    lineHeight: 17,
  },
  errorBanner: {
    marginBottom: 12,
    padding: 9,
    borderRadius: 6,
    backgroundColor: '#FFF0EB',
    borderWidth: 1,
    borderColor: '#F1B8A8',
  },
  errorText: {
    fontSize: 11,
    color: AdminColors.red500,
    fontFamily: FontFamily.regular,
    lineHeight: 16,
  },
  masterRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 10,
  },
  masterButton: {
    fontSize: 11,
    fontWeight: '700',
    color: AdminColors.blue800,
    fontFamily: FontFamily.bold,
  },
  routeToolbar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  routeToolbarLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
    flex: 1,
    minWidth: 250,
  },
  routeToolbarActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
  },
  routeSearchBox: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 36,
    paddingHorizontal: 10,
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 6,
    backgroundColor: AdminColors.bgSurface,
    flex: 1,
    minWidth: 220,
  },
  routeSearchIcon: {
    marginRight: 6,
  },
  routeSearchInput: {
    flex: 1,
    fontSize: 13,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.regular,
    outlineWidth: 0,
    paddingVertical: 0,
  } as any,
  routeCountText: {
    fontSize: 12,
    color: AdminColors.textMuted,
    fontFamily: FontFamily.regular,
  },
  routeErrorBanner: {
    marginBottom: 12,
    padding: 9,
    borderRadius: 6,
    backgroundColor: '#FFF0EB',
    borderWidth: 1,
    borderColor: '#F1B8A8',
  },
  routeErrorText: {
    fontSize: 11,
    color: AdminColors.red500,
    fontFamily: FontFamily.regular,
    lineHeight: 16,
  },
  routeToggle: {
    width: 36,
    height: 20,
    borderRadius: 10,
    padding: 2,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  routeToggleOn: {
    backgroundColor: AdminColors.green400,
  },
  routeToggleOff: {
    backgroundColor: '#E0E0E0',
  },
  routeThumb: {
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
  },
  routeThumbOn: {
    alignSelf: 'flex-end',
  },
  routeThumbOff: {
    alignSelf: 'flex-start',
  },
});

export const confirmStyles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  box: {
    backgroundColor: AdminColors.bgSurface,
    borderRadius: 10,
    padding: 24,
    maxWidth: 460,
    width: '100%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.2,
    shadowRadius: 24,
    elevation: 20,
  },
  title: {
    fontSize: 16,
    fontWeight: '700',
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.bold,
    marginBottom: 10,
  },
  message: {
    fontSize: 13,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.regular,
    lineHeight: 20,
    marginBottom: 20,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 10,
  },
});
